import ReactEcharts from "echarts-for-react";

export function SimplePieChart({ style, dados = [] }) {
  const color = ["#90CBF0", "#D98772"];

  const option = {
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        return `${params.name}: ${params.value}%`;
      },
    },
    legend: {
      orient: "vertical",
      left: "right",
      top: "bottom",
      textStyle: {
        fontWeight: "bold",
      },
      selectedMode: false,
    },
    series: [
      {
        name: "Gênero",
        type: "pie",
        radius: "50%",
        data: dados,
        color: color,
        label: {
          formatter: "{d}%",
          position: "inside",
          fontSize: 20,
          fontWeight: "bold",
          color: "white",
          textBorderColor: "#777",
          textBorderWidth: 2,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return <ReactEcharts option={option} style={style} />;
}
